import { get, post } from '@web3/base-utils';
import { baseApiUrl } from '@/config/api';
import {
  PostRewardClaimParams,
  GetClaimFeeParams,
  GetClaimFeeRes,
  GetRewardQueryV2Params,
  GetRewardQueryV2Res,
  GetRewardQueryV3Params,
  GetRewardQueryV3Res,
  PostClaimEncodeParams,
  PostClaimEncodeRes,
  PostSaveClaimOrderParam,
  PostSaveClaimOrderRes,
} from '@/types/claim';
import { feeLevelMap } from '@/config/map';

/** 获取链余额 */
export const getRewardQueryV2 = (params: GetRewardQueryV2Params) => {
  return get<GetRewardQueryV2Res>(`${baseApiUrl}/v2/reward/query`, params, {
    useThirdConfig: true,
  });
};

/** 获取链余额 */
export const getRewardQueryV3 = (params: GetRewardQueryV3Params) => {
  return get<GetRewardQueryV3Res>(`${baseApiUrl}/v3/reward/query`, params, {
    useThirdConfig: true,
  });
};

export const getClaimFee = (params: GetClaimFeeParams) => {
  return get<GetClaimFeeRes>(`${baseApiUrl}/v2/reward/claim/fee`, {
    ...params,
    baseFee: 1,
    maxPriorityFeePerGas: 1,
    level: feeLevelMap[params.level || 'middle'],
  });
};

export const postRewardClaim = (params: PostRewardClaimParams) => {
  return post<string>(`${baseApiUrl}/v2/reward/claim`, params);
};

export const postClaimEncode = (params: PostClaimEncodeParams) => {
  return post<PostClaimEncodeRes>(`${baseApiUrl}/v3/claim/encode`, params, {
    useThirdConfig: true,
  });
};

export const postSaveClaimOrder = (params: PostSaveClaimOrderParam) => {
  return post<PostSaveClaimOrderRes>(
    `${baseApiUrl}/v3/claim/saveClaimOrder`,
    params
  );
};
